import React, { useState } from "react";
import CustomMargin from "../../../components/custom-margin";
import { ChevronDownIcon } from "@heroicons/react/solid";

export const FAQ_ITEMS = [
    {
        question: "How much are your legal services?",
        answer:
            "The Quilaton Law Office follows the standard minimum attorney's fee schedule regulated by the Integrated Bar of the Philippines (IBP) Cebu City Chapter, which is the official organization of lawyers recognized by the Supreme Court. For more details, kindly contact us and we will respond to you as soon as possible.",
    },
    {
        question: "What are the payment options you accept?",
        answer:
            "We cater the following modes of payment: Cash, Eastwest Bank Transfer, BPI Bank Transfer, GCash, or via Remittance Centers.",
    },
    {
        question: "Do I really need an attorney?",
        answer:
            "When in doubt about your legal concerns, it is highly recommended to reach out to a lawyer as soon as possible to avoid your circumstances from escalating. Whether you are looking for a retainer lawyer for your business or other personal matters, you can rely on Quilaton Law Office.",
    },
];

export default function FAQSection() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAnswer = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="my-16">
            <CustomMargin>

                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-zinc-700 via-zinc-300 to-zinc-700 p-[1px] shadow-[0_0_30px_rgba(255,255,255,0.08)]">

                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-b from-[#181818] via-[#0d0d0d] to-black">

                        {/* Metallic shine */}
                        <div className="absolute inset-0 bg-[linear-gradient(120deg,transparent_20%,rgba(255,255,255,.05)_45%,transparent_75%)] pointer-events-none" />

                        {/* Top highlight */}
                        <div className="absolute top-0 left-0 h-24 w-full bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />

                        <div className="relative z-10 p-8 lg:p-10">

                            <div className="text-center mb-10">
                                <h2 className="text-4xl text-white tracking-[0.25em] font-fontMontserrat">
                                    FAQ
                                </h2>

                                <div className="mx-auto mt-4 h-px w-20 bg-gradient-to-r from-transparent via-zinc-300 to-transparent" />

                                <p className="mt-4 text-zinc-400">
                                    Frequently Asked Questions
                                </p>
                            </div>

                            <div className="space-y-4">

                                {FAQ_ITEMS.map((item, index) => (
                                    <div
                                        key={item.question}
                                        className="rounded-2xl border border-zinc-700 overflow-hidden transition-all duration-300 hover:border-zinc-500"
                                    >

                                        <button
                                            onClick={() => toggleAnswer(index)}
                                            className="w-full flex items-center justify-between px-6 py-5 text-left bg-white/[0.02] hover:bg-white/[0.05] transition-all duration-300"
                                        >
                                            <span className="text-white text-lg font-medium">
                                                {item.question}
                                            </span>

                                            <ChevronDownIcon
                                                className={`w-6 h-6 text-zinc-300 transition-transform duration-300 ${
                                                    openIndex === index
                                                        ? "rotate-180"
                                                        : ""
                                                }`}
                                            />
                                        </button>

                                        <div
                                            className={`overflow-hidden transition-all duration-500 ${
                                                openIndex === index
                                                    ? "max-h-96"
                                                    : "max-h-0"
                                            }`}
                                        >
                                            <div className="border-t border-zinc-800 px-6 py-5">
                                                <p className="text-zinc-400 leading-8">
                                                    {item.answer}
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </div>

            </CustomMargin>
        </section>
    );
}
